import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RadioButton, Card } from 'components'
import { tokenService } from 'services'
import { CONTACT_OPTIONS, CONTACT_OPTIONS_LABEL, CONTACT_TYPE } from 'app-constants'
import { setDrawerAlert } from 'slices/drawer'
import { getMaskedContact } from 'utils'
import { ActionContainer } from '../action-container'
import {
  CONFIRM_SUBSCRIPTION_STEPS,
  CONTACT_OPTIONS_ICON,
  DEFAULT_ERROR_GENERATE_TOKEN_MESSAGE,
} from '../../constants'
import './style.scss'

export function SelectContact({
  isLoading,
  setCurrentStep,
  setIsLoading,
  setContactToken,
  contactTokenType,
  setContactTokenType,
  document,
}) {
  const [options, setOptions] = useState({})
  const { contacts } = useSelector(({ customer }) => customer.info)
  const { generateToken } = tokenService()
  const dispatch = useDispatch()

  useEffect(() => {
    const phone = contacts.find(
      contact => contact.principal && contact.contactType === CONTACT_TYPE.PHONE
    )
    const email = contacts.find(
      contact => contact.principal && contact.contactType === CONTACT_TYPE.EMAIL
    )

    setOptions({
      [CONTACT_OPTIONS.SMS]: phone,
      [CONTACT_OPTIONS.EMAIL]: email,
    })
  }, [contacts])

  function handleBackClick() {
    setCurrentStep(CONFIRM_SUBSCRIPTION_STEPS.REVIEW)
  }

  async function handleConfirmClick() {
    setIsLoading(true)
    try {
      const { contact } = options[contactTokenType]
      await generateToken(document, contact, contactTokenType)
      setContactToken(contact)
      setCurrentStep(CONFIRM_SUBSCRIPTION_STEPS.TOKEN_VALIDATION)
    } catch (error) {
      const errorMessage = error?.response?.data?.message || DEFAULT_ERROR_GENERATE_TOKEN_MESSAGE
      dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
    } finally {
      setIsLoading(false)
    }
  }

  function renderOption(name) {
    const { contact } = options[name] || {}

    if (!contact) return null

    return (
      <Card
        className={`contact-option ${contactTokenType === name && '-selected'}`}
        onClick={() => setContactTokenType(name)}
        key={name}
      >
        <RadioButton id={name} checked={contactTokenType === name} />
        <div className='icon'>{CONTACT_OPTIONS_ICON[name]}</div>
        <div className='contact'>
          <span className='type'>{CONTACT_OPTIONS_LABEL[name]}</span>
          <span className='value'>({getMaskedContact(contact)})</span>
        </div>
      </Card>
    )
  }

  return (
    <div className='select-contact-container'>
      <h3 className='title'>Validação de segurança</h3>
      <p className='description'>Escolha como deseja receber o código de validação da sua compra</p>
      <div className='contact-options'>
        {renderOption(CONTACT_OPTIONS.SMS)}
        {renderOption(CONTACT_OPTIONS.EMAIL)}
      </div>
      <ActionContainer
        labelConfirm='Receber código'
        onBack={handleBackClick}
        onConfirm={handleConfirmClick}
        isLoading={isLoading}
        disabled={!contactTokenType}
      />
    </div>
  )
}
